<template>
  <DynamicScroller
    ref="scroller"
    :buffer="buffer"
    :items="items"
    :min-item-size="minItemSize"
    class="dvl-Scroller"
    emit-update
    page-mode
    @update="onUpdate"
    @scroll-end="onScrollEnd"
    @scroll-start="onScrollStart"
  >
    <template #default="{ item, index, active }">
      <DynamicScrollerItem
        :active="active"
        :data-index="index"
        :item="item"
        :size-dependencies="generateSizeDependencies(sizeDependencies)"
      >
        <slot
          :active="active"
          :index="index"
          :is-last="index === items.length - 1"
          :item="item"
          name="item"
        />
      </DynamicScrollerItem>
    </template>
    <template v-if="loading" #after>
      <slot name="loading" />
    </template>
  </DynamicScroller>
</template>

<script setup>
import { useTemplateRef } from 'vue'
import { DynamicScroller, DynamicScrollerItem } from 'vue-virtual-scroller'

import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'

defineOptions({
  name: 'DynamicVirtualizationList'
})

const props = defineProps({
  items: {
    type: Array,
    default: () => []
  },

  minItemSize: {
    type: Number,
    default: 50
  },

  buffer: {
    type: Number,
    default: 50
  },

  sizeDependencies: {
    type: Array,
    default: () => []
  },

  loading: {
    type: Boolean
  }
})

const emit = defineEmits({
  'bottom-arrived': null,
  'top-arrived': null,
  'display-items-update': null
})

const onScrollEnd = () => {
  emit('bottom-arrived')
}

const onScrollStart = () => {
  emit('top-arrived')
}

const generateSizeDependencies = item => {
  return [item, ...props.sizeDependencies.map(key => item[key])]
}

const onUpdate = (startIndex, endIndex, visibleStartIndex, visibleEndIndex) => {
  emit('display-items-update', {
    startIndex,
    endIndex,
    visibleStartIndex,
    visibleEndIndex
  })
}

const scrollerRef = useTemplateRef('scroller')

const scrollToItemByIndex = ({
  index = 0,
  makeSecondAttempt = true,
  secondAttemptTimeout = 0
} = {}) => {
  return new Promise(resolve => {
    if (index < 0 || index >= props.items.length) {
      return resolve()
    }

    const scrollToItem = () => scrollerRef.value.scrollToItem(index)

    scrollToItem()

    setTimeout(() => {
      if (makeSecondAttempt) {
        scrollToItem()
      }

      resolve()
    }, secondAttemptTimeout)
  })
}

defineExpose({
  scrollToItemByIndex
})
</script>

<style lang="scss" scoped>
.dvl-Scroller {
}
</style>
